import { render, staticRenderFns } from "./ServiceCharge.vue?vue&type=template&id=3d2353bc&"
import script from "./ServiceCharge.vue?vue&type=script&lang=ts&"
export * from "./ServiceCharge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports